import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import { getPrincipal } from "./auth";
import { initGenerator } from "./generator";
import { renderNav } from "./nav";
import { initTheme } from "./theme";

initTheme();

const app = document.getElementById("app");
if (app) {
	document.getElementById("unsupported")?.remove();
	app.hidden = false;
	initGenerator(app);
}

const nav = document.getElementById("navActions");
if (nav) {
	renderNav(nav, null, "generator");
	void getPrincipal().then((p) => renderNav(nav, p, "generator"));
}
